import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import axios from "axios";
import { reportRetentionsExistsTypes } from "redux/reducers/Reports/reportRetentionsExists/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_RETENTIONS_EXISTS_FILTERS } = reportRetentionsExistsTypes;

export const getReportRetentionsExistsAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/reports/retention-exits?start=${startDate}&end=${endDate}&idStation=${station.id}&pdf=${isPdf}`;
    const fileName = `Reporte_Salidas_Retenciones_${station.name}_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`;

    dispatch(startRequestComp('loadingRetentionsExists'));
    try {
      const file = await axios({
        url: reportUrl,
        method: 'GET',
        responseType: 'blob',
        headers: { authorization: token }
      });

      saveAs(file.data, fileName);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingRetentionsExists'));
    }
  };
};

export const setReportRetentionsExistsFilters = (key = "", value) => ({
  type: SET_RETENTIONS_EXISTS_FILTERS,
  payload: { key, value }
});
